import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import PropTypes from 'prop-types';
import SortableMenuElement from './Element';

const SortableMenuContainer = ({ items, default_language, onOpenModal }) => (
  <div className="menu-list__container">
    {items.map((item, index) => (
      <SortableMenuElement key={`item-${item.id}`} index={index} {...item} default_language={default_language} onOpenModal={onOpenModal} />
    ))}
  </div>
);

SortableMenuContainer.propTypes = {
  default_language: PropTypes.string,
  onOpenModal: PropTypes.func,
  items: PropTypes.array,
};

export default SortableContainer(SortableMenuContainer);
